export const T = {
  en_GB: { loading: "Loading note...", fallbackTitle: "Note" },
  nb_NO: { loading: "Laster notat...", fallbackTitle: "Notat" },
} as const;
